import List from 'Blocks/List';

type NeverFoundIngredientsListProps = {
  content: {
    categoryTitle: string;
    data: string[][];
    intro: string;
    title: string;
  };
};

export const NeverFoundIngredientsList = ({
  content: { categoryTitle, data, intro, title },
}: NeverFoundIngredientsListProps) => (
  <List categoryTitle={categoryTitle} data={data} intro={intro} title={title} />
);
